import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


const styles = {
	root: {
		display: 'flex',
		flexFlow: 'column',
		// alignItems: 'center',
		// justifyContent: 'center',
		height: '500px',
		width: '100%'
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		alignContent: 'space-around',
	},
	item: {
		padding: '1.2em'
	}
};

export default function ErrorPage({ title = ':( Sorry!', message = 'An unexpected error occurred.' }) {
	return (
		<div style={styles.root}>
			<div style={styles.container}>
				<div style={styles.item}>
					<Typography variant="h3" color="primary" noWrap style={{ fontWeight: 'bolder' }}>
						{title}
					</Typography>
				</div>
				<div style={styles.item}>
					<Typography variant="h4" color="textSecondary" noWrap>
						{message}
					</Typography>
				</div>
				<div style={{ ...styles.item, paddingTop: '3em' }}>
					<Typography variant="h5" color="textSecondary" noWrap>
						<FormattedMessage id="Extensions.ErrorPage.LoginHint" defaultMessage="Please login in again" />
					</Typography>
				</div>
				<div style={styles.item}>
					<Button variant="outlined" color="primary" onClick={() => { window.location = '/login'; }}>
						<Typography variant="button" color="primary" noWrap>
							<FormattedMessage id="Login" defaultMessage="Login" />
						</Typography>
					</Button>
				</div>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/sharemachine/ErrorPage.js